import { ref } from 'vue'

import { useHotkeys } from '@/composables/hotkeys/useHotkeys'

export function useHotkeyHelp() {
  const isHelpVisible = ref(false)

  function toggleHelp(): void {
    isHelpVisible.value = !isHelpVisible.value
  }

  useHotkeys(
    'hotkey-help',
    {
      '?': { handler: toggleHelp, modifiers: { shift: true }, description: 'hotkeys.showHelp' }
    },
    { priority: 100 }
  )

  return {
    isHelpVisible
  }
}
